module.exports = __webpack_public_path__ + "img/krebsehalesalat.7e8377df.jpg";